import { defineComponent, PropType } from "vue";
import { Container } from "aurelia-dependency-injection";
import moment from "moment";
import { required, requiredIf } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

import { ITypeaheadOptions } from "../../../../../../../interfaces/i-typeahead";
import { formatDateInput } from "../../../../../../../common/vue-helpers/modifiers/value-modifier";
import { EnumMap } from "../../../../../../../common/enum-map";
import { IImmunizationRecord, PatientService } from "../../../../../../../services/patient.service";

import TypeaheadInput from "../../../../../../../resources-vue/vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";
import FormSection from "../../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import DatePicker from "../../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";

export default defineComponent({
    props: {
        application: {
            type: Number
        },
        immunization: {
            type: Object as PropType<IImmunizationRecord>
        },
        isViewOnly: {
            type: Boolean
        },
        isEdit: {
            type: Boolean
        },
        typeOfRecordEnum: {
            type: Array
        },
        immunizationStatusEnumMap: {
            type: EnumMap
        },
        immunizationStatusEnum: {
            type: Array
        }
    },

    components: {
        FormSection,
        DatePicker,
        TypeaheadInput
    },

    validations() {
        return {
            immunization: {
                CvxCode: { required },
                DateOfVaccination: {
                    required: requiredIf(
                        this.immunizationStatusEnumMap.checkEnumValue("Completed", this.immunization.Status)
                    )
                },
                TypeOfRecord: { required },
                Status: { required }
            }
        };
    },

    data(vm) {
        return {
            _patientService: null,
            selectedVaccine: null,
            datePickerOptions: {
                endDate: moment().format("MM/DD/YYYY")
            } as DatepickerOptions,
            v$: useVuelidate(),
            formatDateInput
        };
    },

    created() {
        this._patientService = Container.instance.get(PatientService);
    },

    mounted() {
        if (!!this.immunization?.ProductName) {
            let displayName = `${this.immunization.ProductName} [${this.immunization.Description}]`;
            this.selectedVaccine = {
                name: displayName,
                value: this.immunization.ProductName,
                mvxCode: this.immunization.MvxCode,
                cvxCode: this.immunization.CvxCode,
                manufacturer: this.immunization.Manufacturer,
                description: this.immunization.Description
            };
        }
    },

    methods: {
        async getVaccineList(filter: string, limit: number) {
            const query = {
                application: this.application,
                searchTerm: filter
            };
            let vaccineList = await this._patientService.getSearchImmunization(query);
            return vaccineList.data.map((vaccine: any) => {
                let displayName = `${vaccine.ProductName} [${vaccine.Description}]`;
                return {
                    name: displayName,
                    value: vaccine.ProductName,
                    cvxCode: vaccine.CvxCode,
                    mvxCode: vaccine.MvxCode,
                    manufacturer: vaccine.Manufacturer,
                    description: vaccine.Description
                };
            });
        },

        resetImmunizationVaccine() {
            this.immunization.CvxCode = "";
            this.immunization.Manufacturer = "";
            this.immunization.MvxCode = "";
            this.immunization.ProductName = "";
            this.immunization.Description = "";
        },

        selectedVaccineChanged(newValue: ITypeaheadOptions) {
            this.selectedVaccine = newValue;
            if (!!this.selectedVaccine) {
                this.immunization.CvxCode = this.selectedVaccine.cvxCode;
                this.immunization.Manufacturer = this.selectedVaccine.manufacturer;
                this.immunization.MvxCode = this.selectedVaccine.mvxCode;
                this.immunization.ProductName = this.selectedVaccine.value;
                this.immunization.Description = this.selectedVaccine.description;
            } else {
                this.resetImmunizationVaccine();
            }
        },

        handleDateChange(date: string, name: string) {
            this.immunization.DateOfVaccination = date;
        },

        handleDateInputChange(e: any) {
            this.immunization.DateOfVaccination = e.target.value;
        }
    }
});
